import type { FunctionComponent } from "react";

import { Tabs, Tab } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { EKeywordTabs } from "app/UtilitiesAndConstants/Constants/SourceTypes";
import { isPaidKwSearchAvailable } from "app/pages/keyword-research/utils/permissions";
import { useSelectedPageTab } from "app/custom-hooks/useSelectedPageTab";
import { TabListStyled } from "app/components/keyword-research/landing-pages/styledComponents";
import { allTrackers } from "app/services/track/track";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { Pages } from "./Pages";

export const KeywordUrlPage = () => {
    const { selectedPageTabIndex, setSelectedPageTabIndex } = useSelectedPageTab(EKeywordTabs);
    const onPageTabSelect = (index: EKeywordTabs) => {
        const selectedTabKey = EKeywordTabs[index];
        setSelectedPageTabIndex(index);
        void proNavigator.updateParams({ selectedPageTab: selectedTabKey });
        allTrackers.dispatchTrackEvent("Tab", "click", `Change page tab/${selectedTabKey}`);
    };

    return (
        <Tabs
            onSelect={onPageTabSelect}
            selectedIndex={selectedPageTabIndex}
        >
            <TabListStyled size={"lg"}>
                <Tab id={EKeywordTabs.Total}>{translate("trafficanalysis.tab.total.traffic")}</Tab>
                <Tab id={EKeywordTabs.Organic}>{translate("trafficanalysis.tab.organic.traffic")}</Tab>
                {isPaidKwSearchAvailable() ? (
                    <Tab id={EKeywordTabs.Paid}>{translate("trafficanalysis.tab.paid.traffic")}</Tab>
                ) : null}
            </TabListStyled>
            <Pages />
        </Tabs>
    );
};
